import {combineReducers} from 'redux';
import accountReducer from './accountReducer';
import searchRunsReducer from './searchRunsReducer';
import checklistReducer from './checklistReducer';
import driverRunsReducer from './driverRunsReducer';
import runReducer from './runReducer';
import locationReducer from './locationReducer';
import driverLocationsReducer from './driverLocationsReducer';
import driversReducer from './driversReducer';
import trucksReducer from './trucksReducer';
import newRunReducer from './newRunReducer';
import regionsReducer from './regionsReducer';
import usersReducer from './usersReducer';
import rolesReducer from './rolesReducer';
import bdmsReducer from './bdmsReducer';
import clientsReducer from './clientsReducer';
import locationsReducer from './locationsReducer';
import unmappedSuburbsReducer from './unmappedSuburbsReducer';
import truckDataReducer from './truckDataReducer';
import runReceiptsReducer from './runReceiptsReducer';
import apiConfigReducer from './apiConfigReducer';
import { reducer as oidcReducer } from 'redux-oidc';
import {reducer as toastrReducer} from 'react-redux-toastr';
import rebatesRCTIReducer from './rebatesRCTIReducer';
import integrationReducer from './integrationReducer';
import homeRCTIReducer from './homeReducer';
import clientRequestsReducer from './clientRequestsReducer';

const rootReducer = combineReducers({
    oidc: oidcReducer,
    account: accountReducer,
    checklists: checklistReducer,
    toastr: toastrReducer,
    driverRuns: driverRunsReducer,
    searchRuns: searchRunsReducer,
    run: runReducer,
    location: locationReducer,
    driverLocations: driverLocationsReducer,
    drivers: driversReducer,
    trucks: trucksReducer,
    newRun: newRunReducer,
    regions: regionsReducer,
    unmappedSuburbs: unmappedSuburbsReducer,
    users: usersReducer,
    roles: rolesReducer,
    bdms: bdmsReducer,
    clients: clientsReducer,
    locations: locationsReducer,
    truckData: truckDataReducer,
    runReceipts: runReceiptsReducer,
    apiConfig: apiConfigReducer,
    rebatesRCTI: rebatesRCTIReducer,
    integrations: integrationReducer,
    home: homeRCTIReducer,
    clientRequests: clientRequestsReducer
});

export default rootReducer;
